import React from 'react';
import ReactTimeAgo from "react-time-ago";

export const PrismTimeFormatter = (dateInput) => {
  const date = new Date(dateInput);

  // Check for invalid date
  if (isNaN(date.getTime())) {
    return null;
  }

  const now = new Date();
  const differenceInHours = Math.abs(now - date) / (1000 * 60 * 60);
  const differenceInDays = differenceInHours / 24;

  if (differenceInHours < 24) {
    return <ReactTimeAgo tooltip={true} date={date} locale="en-US" timeStyle="round" />;
  } else if (differenceInDays > 30 && date.getFullYear() === now.getFullYear()) {
    // Format: "12:10 PM, Jan 13"
    const time = new Intl.DateTimeFormat('en', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    }).format(date);

    const day = new Intl.DateTimeFormat('en', {
      month: 'short',
      day: '2-digit',
    }).format(date);

    return `${time}, ${day}`;
  } else if (date.getFullYear() !== now.getFullYear()) {
    // Format: "13 Jan, 2022"
    return new Intl.DateTimeFormat('en', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }).format(date);
  } else {
    // Format: "12:10 PM, Jan 13"
    const time = new Intl.DateTimeFormat('en', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    }).format(date);

    const day = new Intl.DateTimeFormat('en', {
      month: 'short',
      day: '2-digit',
    }).format(date);

    return `${time}, ${day}`;
  }
};

export const formatAutoShort = (dateInput) => {
  const date = new Date(dateInput);

  if (isNaN(date.getTime())) {
    return '';
  }

  // Format: "12:10 PM, Jan 13"
  const time = new Intl.DateTimeFormat('en', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).format(date);

  const day = new Intl.DateTimeFormat('en', {
    month: 'short',
    day: '2-digit',
  }).format(date);

  return `${time}, ${day}`;
};
